<template>
  <section test_id="bio-section">
    <ProfileVideo v-if="isProfileVideoComponentShown" :video="profileVideo" />
    <Card
      :class="{
        '!tw-rounded-t-none': isProfileVideoComponentShown,
      }"
    >
      <div class="tw-flex tw-items-center tw-justify-between">
        <h2 class="tw-heading-2">Bio</h2>
        <EditBiography
          v-if="isEditModeEnabled"
          :biography="biography"
          :video="profileVideo?.url"
          :about-me="aboutMe"
        />
      </div>
      <!--The prettier-ignore is only for strange whitespace formatting.-->
      <!-- prettier-ignore -->
      <p class="tw-mt-4 tw-whitespace-pre-line tw-text-break" test_id="bio-about-me">{{ biography || 'No bio added...' }}</p>
    </Card>
  </section>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import EditBiography from './EditBiography.vue'
import ProfileVideo from './ProfileVideo.vue'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'

defineProps({
  biography: {
    type: String,
    default: '',
  },
  aboutMe: {
    type: String,
    default: '',
  },
})

const page = usePage()
const { isEditModeEnabled } = useEditProfileModeInjector()

const profileVideo = computed(() => page.props.profileVideo)
const isProfileVideoComponentShown = computed(() => {
  return profileVideo.value?.url || isEditModeEnabled.value
})
</script>
